/*
 * file: AxiosCall.js
 * 상세: API
 */

import axios from "axios";
import store from '../store';

import { Empty } from "utils/function";
import { ApiUrl } from "common/datas";
import { newToken } from "../store/actions";

const axiosClient = axios.create({
    baseURL: `${ApiUrl}/api`,
    withCredentials: true,
})

axiosClient.interceptors.request.use((config) => {
    const state = store.getState();
    config.headers.Authorization = `Bearer ${!Empty(state) && state.Client.token.access_token}`
    return config;
})

axiosClient.interceptors.response.use((response) => response,
    async (error) => {
        const { response } = error;
        if (response.status === 401) {
            try {
                // /refresh-token API를 호출하여 토큰 갱신 시도
                const { Client } = store.getState();
                const response = await axios.get(`${ApiUrl}/api/refresh-token`, {
                    headers: {
                        'Authorization': `Bearer ${Client.token.refresh_token}`
                    }
                })
                // 토큰 갱신
                store.dispatch(newToken(response.data.token));

                const originalRequest = error.config;
                originalRequest.headers.Authorization = `Bearer ${response.data.token.access_token}`;
                return axiosClient(originalRequest);
            } catch (err) {
                localStorage.clear();
                window.location.href = `${window.location.origin}/`
            }
        }
        return Promise.reject(error)
    }
)

export default axiosClient;
